module.exports = __webpack_public_path__ + "static/media/404.893b0dd9.png";